import { render, staticRenderFns } from "./CmptRec.vue?vue&type=template&id=6a7959d6&scoped=true&lang=pug&"
import script from "./CmptRec.vue?vue&type=script&lang=js&"
export * from "./CmptRec.vue?vue&type=script&lang=js&"
import style0 from "./CmptRec.vue?vue&type=style&index=0&id=6a7959d6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7959d6",
  null
  
)

export default component.exports